import { createContext, useContext, useEffect, useState } from "react";

export const translations = {
  ar: {
    brand: "برق سيف",
    tagline: "لحلول الأعمال",
    nav_services: "خدماتنا",
    nav_investors: "للمستثمرين الأجانب",
    nav_packages: "الباقات",
    nav_faq: "الأسئلة الشائعة",
    nav_contact: "تواصل معنا",
    cta_consult: "استشارة مجانية",
    hero_overline: "حلول الأعمال الإلكترونية — المملكة العربية السعودية",
    hero_l1: "نجّز معاملاتك الحكومية",
    hero_l2: "بسرعة البرق،",
    hero_l3: "وبأمانٍ تام.",
    hero_sub: "يدير فريق برق سيف حسابات منشأتك على جميع المنصات الحكومية — قوى، مقيم، أبشر أعمال، وزارة التجارة، بلدي، التأمينات وغيرها — ويؤسس الشركات للمستثمرين الأجانب من الصفر، لتتفرغ أنت لتنمية أعمالك.",
    hero_cta1: "احصل على استشارة مجانية",
    hero_cta2: "استكشف خدماتنا",
    hero_scroll: "اسحب للأسفل",
    stats: [
      { n: "+500", l: "معاملة حكومية منجزة" },
      { n: "+200", l: "منشأة نخدمها" },
      { n: "98%", l: "نسبة رضا العملاء" },
      { n: "+10", l: "سنوات من الخبرة" },
    ],
    marquee_items: ["قوى", "مقيم", "أبشر أعمال", "وزارة التجارة", "المركز السعودي للأعمال", "وزارة الاستثمار", "التأمينات الاجتماعية", "منصة بلدي", "الزكاة والضريبة والجمارك", "حماية الأجور — مدد"],
    ch_services: "المنصات الحكومية",
    services_title: "نغطي جميع المنصات الحكومية نيابةً عنك",
    services_sub: "فوّضنا مرة واحدة، ودعنا ندير كل معاملاتك الإلكترونية بدقة واحترافية والتزام كامل بالأنظمة.",
    services: [
      { name: "منصة قوى", desc: "إدارة الموظفين، توثيق العقود، إصدار رخص العمل، ونقل الخدمات." },
      { name: "منصة مقيم", desc: "إصدار وتجديد الإقامات، تأشيرات الخروج والعودة، والتقارير." },
      { name: "أبشر أعمال", desc: "فتح الحساب، إدارة التفاويض، وخدمات الجوازات للمنشآت." },
      { name: "وزارة التجارة", desc: "إصدار وتجديد السجلات التجارية والتعديلات وحجز الأسماء." },
      { name: "المركز السعودي للأعمال", desc: "بدء النشاط التجاري وإصدار التراخيص عبر نافذة موحدة." },
      { name: "وزارة الاستثمار", desc: "إصدار وتعديل رخص الاستثمار الأجنبي (MISA) بجميع أنواعها." },
      { name: "التأمينات الاجتماعية", desc: "تسجيل المنشأة والموظفين وإدارة الاشتراكات والمطالبات." },
      { name: "منصة بلدي", desc: "الرخص البلدية والتجارية وتراخيص المحلات واللوحات." },
      { name: "الزكاة والضريبة والجمارك", desc: "التسجيل، تقديم الإقرارات، وإصدار شهادات الزكاة والضريبة." },
      { name: "حماية الأجور — مدد", desc: "رفع ملفات الأجور الشهرية والالتزام الكامل بنظام حماية الأجور." },
    ],
    ch_investors: "تأسيس الشركات",
    investors_title: "أسّس شركتك في السعودية من أي مكان في العالم",
    investors_sub: "باقة متكاملة للمستثمر الأجنبي: من رخصة الاستثمار حتى تشغيل منشأتك، نمشي معك خطوة بخطوة حتى تبدأ أعمالك قانونياً وبسرعة قياسية.",
    investors_points: [
      "إصدار رخصة وزارة الاستثمار السعودية (MISA)",
      "صياغة وتوثيق عقد التأسيس إلكترونياً",
      "إصدار السجل التجاري والعنوان الوطني",
      "فتح الحسابات البنكية للشركات",
      "تأشيرات وإقامات الشركاء والمديرين",
      "التسجيل في الزكاة والتأمينات وقوى",
    ],
    investors_cta: "ابدأ تأسيس شركتك",
    investors_more: "تفاصيل خطوات التأسيس الكاملة ←",
    investors_badge: "خدمة مميزة",
    ch_process: "كيف نعمل",
    process_title: "أربع خطوات وتنتهي معاملتك",
    process_steps: [
      { t: "تواصل واستشارة مجانية", d: "احجز استشارتك واشرح احتياجك، ونحدد لك المتطلبات والتكلفة بدقة." },
      { t: "التفويض وجمع المتطلبات", d: "نجهز التفاويض الرسمية والمستندات المطلوبة ونراجعها معك." },
      { t: "التنفيذ على المنصات", d: "ننفذ معاملتك على المنصات الحكومية بمتابعة لحظية حتى الاعتماد." },
      { t: "التسليم والمتابعة", d: "نسلمك المستندات المعتمدة ونبقى معك للتجديد والدعم المستمر." },
    ],
    ch_packages: "الباقات السنوية",
    packages_title: "باقات مصممة لحجم منشأتك",
    packages_sub: "اشتراك سنوي واحد يغنيك عن توظيف مختص حكومي — ندير كل ملفات منشأتك.",
    per_year: "/ سنوياً",
    most_popular: "الأكثر طلباً",
    choose_package: "اطلب الباقة",
    packages: [
      {
        name: "الفضية", price: "4,666", target: "للشركات الصغيرة (1–4 موظفين)",
        features: ["خدمات منصة قوى", "خدمات أبشر ومقيم", "خدمات وزارة التجارة", "خدمات منصة بلدي", "التأمينات الاجتماعية", "خدمات التأمين الطبي"],
      },
      {
        name: "الذهبية", price: "8,667", target: "للشركات المتنامية (1–10 موظفين)",
        features: ["كل مزايا الباقة الفضية", "خدمات الزكاة والدخل", "خدمات سلامة", "خدمات الاستشارات", "حماية الأجور (مدد)"],
      },
      {
        name: "الماسية", price: "13,600", target: "للشركات المتوسطة (1–25 موظفاً)",
        features: ["كل مزايا الباقة الذهبية", "توثيق عقود العمل للموظفين", "خدمات وزارة الإعلام", "خدمات البريد السعودي", "خدمات تخفيف الأعباء"],
      },
    ],
    ch_why: "لماذا برق سيف",
    why_title: "شريكك الموثوق في التعاملات الحكومية",
    why_features: [
      { t: "سرعة إنجاز فائقة", d: "نلتزم بمواعيد تسليم واضحة وننجز معاملاتك في أسرع وقت ممكن — هذا ما يعنيه اسمنا." },
      { t: "خبرة بكل منصة", d: "فريق يعرف أنظمة ومتطلبات كل منصة حكومية ويحدّث معلوماته أولاً بأول." },
      { t: "أمان وسرية تامة", d: "بيانات منشأتك محفوظة بسرية كاملة، وجميع التفاويض موثقة ونظامية." },
    ],
    ch_testimonials: "آراء العملاء",
    testimonials_title: "ماذا يقول عملاؤنا",
    testimonials: [
      { q: "ما لفت انتباهي في برق سيف هو السرية التامة في التعامل مع بيانات منشآتنا الطبية، والدقة في كل تفويض. شريك يستحق الثقة فعلاً.", n: "د. إبراهيم التميمي", r: "مستثمر في القطاع الصحي" },
      { q: "سرعة إنجاز غير متوقعة — أنهوا تأسيس شركتنا الناشئة وسجلنا التجاري خلال أيام، وتعاملهم مع المنصات الحكومية احترافي من أول رسالة.", n: "أ. سارة العتيبي", r: "الرئيس التنفيذي لشركة تقنية ناشئة" },
      { q: "يديرون حساباتنا في قوى ومقيم بالكامل؛ رخص العمل والإقامات تُنجز قبل انتهائها بتنبيهات مسبقة. وفّروا علينا موظف شؤون حكومية كامل.", n: "م. خالد الشمري", r: "مدير عام مجموعة مقاولات" },
      { q: "كرائدة أعمال في التجزئة، أكثر ما أعجبني سهولة التواصل ووضوح الخطوات — رخص بلدي والسجل التجاري وصلتني دون أن أزور أي جهة.", n: "أ. منيرة الدوسري", r: "رائدة أعمال في قطاع التجزئة" },
      { q: "من رخصة الاستثمار إلى الحساب البنكي والتأشيرات، مشوا معنا خطوة بخطوة حتى أطلقنا منصتنا اللوجستية. تجربة تأسيس سلسة ومحترفة.", n: "م. فيصل بن جاسم", r: "شريك مؤسس في منصة لوجستية" },
      { q: "أتعامل معهم في ملفات تأسيس الشركات الأجنبية لعملائي؛ التزامهم النظامي واحترافية التوثيق جعلتهم خياري الأول في كل عملية تأسيس.", n: "د. ريم الفايز", r: "مستشارة قانونية للشركات الأجنبية" },
    ],
    ch_faq: "الأسئلة الشائعة",
    faq_title: "لديك سؤال؟ لدينا الإجابة",
    faq: [
      { q: "ما هي المنصات الحكومية التي تغطيها خدماتكم؟", a: "نغطي جميع المنصات الحكومية في المملكة: قوى، مقيم، أبشر أعمال، وزارة التجارة، المركز السعودي للأعمال، وزارة الاستثمار، التأمينات الاجتماعية، منصة بلدي، الزكاة والضريبة والجمارك، مدد وغيرها." },
      { q: "هل يمكنكم تأسيس شركة لمستثمر أجنبي بالكامل عن بُعد؟", a: "نعم، ننجز معظم الخطوات إلكترونياً: رخصة وزارة الاستثمار، عقد التأسيس، السجل التجاري والعنوان الوطني، ونرشدك لخطوات الحضور المطلوبة إن وجدت مثل فتح الحساب البنكي." },
      { q: "كيف تعمل الباقات السنوية؟", a: "باشتراك سنوي واحد نصبح إدارتك الحكومية: ندير حساباتك على المنصات، ننفذ معاملاتك، ونذكّرك بمواعيد التجديد قبل انتهائها." },
      { q: "هل بيانات منشأتي آمنة معكم؟", a: "بالتأكيد. نعمل بتفاويض رسمية موثقة، ونلتزم بسرية تامة لجميع بيانات ومستندات منشأتك، ولا نطلب أي صلاحيات خارج نطاق الخدمة." },
      { q: "كيف أبدأ معكم؟", a: "ببساطة: املأ نموذج الاستشارة المجانية أو راسلنا واتساب على +966 57 946 2600 وسيتواصل معك مختص خلال ساعات العمل." },
    ],
    ch_contact: "تواصل معنا",
    contact_title: "احصل على استشارتك المجانية",
    contact_sub: "أخبرنا باحتياجك وسيتواصل معك مختص من فريق برق سيف في أقرب وقت.",
    form_name: "الاسم الكامل",
    form_phone: "رقم الجوال",
    form_email: "البريد الإلكتروني (اختياري)",
    form_service: "الخدمة المطلوبة",
    form_message: "تفاصيل طلبك",
    form_submit: "أرسل الطلب",
    form_sending: "جارٍ الإرسال...",
    form_success: "تم استلام طلبك بنجاح! سنتواصل معك قريباً.",
    form_error: "تعذر إرسال الطلب، حاول مرة أخرى أو تواصل معنا واتساب.",
    sp_back: "العودة للرئيسية",
    sp_included: "ماذا تشمل الخدمة؟",
    sp_steps: "كيف ننجزها لك؟",
    sp_cta_btn: "اطلب الخدمة الآن",
    sp_all_services: "خدمات أخرى",
    contact_call: "اتصل بنا",
    contact_whatsapp: "واتساب",
    contact_email: "البريد الإلكتروني",
    contact_location: "الموقع",
    contact_location_value: "الرياض، حي السويدي، شارع السويدي العام، داخل القصر مول، ر.ب: 11564",
    map_title: "موقعنا على الخريطة",
    map_directions: "احصل على الاتجاهات",
    stories_link: "اقرأ قصص نجاح عملائنا",
    stories_title: "قصص نجاح حقيقية من عملائنا",
    stories_sub: "أرقام ونتائج ملموسة حققها عملاء برق سيف — من تأسيس الشركات للمستثمرين الأجانب إلى الإدارة الكاملة للمنصات الحكومية.",
    story_challenge: "التحدي",
    story_solution: "الحل",
    story_results: "النتائج بالأرقام",
    story_quote_label: "قالوا عنا",
    service_investor: "تأسيس شركة لمستثمر أجنبي",
    service_other: "خدمة أخرى",
    footer_about: "برق سيف لحلول الأعمال — شريكك الموثوق في إنجاز المعاملات الحكومية الإلكترونية وتأسيس الشركات للمستثمرين الأجانب في المملكة العربية السعودية.",
    footer_links: "روابط سريعة",
    footer_platforms: "المنصات",
    footer_contact: "تواصل",
    footer_rights: "برق سيف لحلول الأعمال — جميع الحقوق محفوظة",
    whatsapp_aria: "تواصل عبر واتساب",
  },
  en: {
    brand: "Barq Safe",
    tagline: "Business Solutions",
    nav_services: "Services",
    nav_investors: "Foreign Investors",
    nav_packages: "Packages",
    nav_faq: "FAQ",
    nav_contact: "Contact",
    cta_consult: "Free Consultation",
    hero_overline: "Electronic Business Solutions — Saudi Arabia",
    hero_l1: "Your government transactions,",
    hero_l2: "done at lightning speed,",
    hero_l3: "with total peace of mind.",
    hero_sub: "The Barq Safe team manages your business accounts across all Saudi government platforms — Qiwa, Muqeem, Absher Business, Ministry of Commerce, Balady, GOSI and more — and forms companies for foreign investors from scratch, so you can focus on growth.",
    hero_cta1: "Get a Free Consultation",
    hero_cta2: "Explore Our Services",
    hero_scroll: "Scroll down",
    stats: [
      { n: "+500", l: "Government transactions completed" },
      { n: "+200", l: "Businesses served" },
      { n: "98%", l: "Client satisfaction" },
      { n: "+10", l: "Years of experience" },
    ],
    marquee_items: ["Qiwa", "Muqeem", "Absher Business", "Ministry of Commerce", "Saudi Business Center", "Ministry of Investment", "GOSI", "Balady Platform", "ZATCA", "Wage Protection — Mudad"],
    ch_services: "Government Platforms",
    services_title: "We cover every government platform on your behalf",
    services_sub: "Authorize us once, and let us run all your e-transactions with precision, professionalism and full compliance.",
    services: [
      { name: "Qiwa Platform", desc: "Employee management, contract authentication, work permits and sponsorship transfers." },
      { name: "Muqeem Platform", desc: "Iqama issuance & renewal, exit/re-entry visas and reports." },
      { name: "Absher Business", desc: "Account setup, authorization management and passport services for businesses." },
      { name: "Ministry of Commerce", desc: "Commercial registration issuance, renewals, amendments and name reservation." },
      { name: "Saudi Business Center", desc: "Start your business and issue licenses through a single window." },
      { name: "Ministry of Investment", desc: "Issuance and amendment of all MISA foreign investment licenses." },
      { name: "GOSI", desc: "Registering your business and employees, subscriptions and claims management." },
      { name: "Balady Platform", desc: "Municipal & commercial licenses, shop and signage permits." },
      { name: "ZATCA", desc: "Registration, tax filing, and Zakat & tax certificates." },
      { name: "Wage Protection — Mudad", desc: "Monthly payroll file uploads and full wage protection compliance." },
    ],
    ch_investors: "Company Formation",
    investors_title: "Form your company in Saudi Arabia from anywhere in the world",
    investors_sub: "A complete package for foreign investors: from the investment license to operating your business — we walk with you step by step until you launch legally and in record time.",
    investors_points: [
      "Ministry of Investment (MISA) license issuance",
      "Drafting & e-notarizing the articles of association",
      "Commercial registration & national address",
      "Corporate bank account opening",
      "Partner & manager visas and residencies",
      "Zakat, GOSI and Qiwa registration",
    ],
    investors_cta: "Start Your Formation",
    investors_more: "Full formation steps →",
    investors_badge: "Signature Service",
    ch_process: "How We Work",
    process_title: "Four steps and your transaction is done",
    process_steps: [
      { t: "Reach out & free consultation", d: "Book your consultation, explain your need, and we define requirements and cost precisely." },
      { t: "Authorization & documents", d: "We prepare official authorizations and required documents and review them with you." },
      { t: "Execution on the platforms", d: "We execute your transaction on government platforms with live follow-up until approval." },
      { t: "Delivery & ongoing support", d: "We hand over your approved documents and stay with you for renewals and support." },
    ],
    ch_packages: "Annual Packages",
    packages_title: "Packages designed for your business size",
    packages_sub: "One annual subscription replaces a government-affairs hire — we manage every file of your business.",
    per_year: "/ yearly",
    most_popular: "Most Popular",
    choose_package: "Choose Package",
    packages: [
      {
        name: "Silver", price: "4,666", target: "For small businesses (1–4 employees)",
        features: ["Qiwa platform services", "Absher & Muqeem services", "Ministry of Commerce services", "Balady platform services", "GOSI services", "Medical insurance services"],
      },
      {
        name: "Gold", price: "8,667", target: "For growing businesses (1–10 employees)",
        features: ["Everything in Silver", "Zakat & income services", "Salama services", "Consulting services", "Wage protection (Mudad)"],
      },
      {
        name: "Diamond", price: "13,600", target: "For medium businesses (1–25 employees)",
        features: ["Everything in Gold", "Employee contract authentication", "Ministry of Media services", "Saudi Post services", "Burden-relief services"],
      },
    ],
    ch_why: "Why Barq Safe",
    why_title: "Your trusted partner in government transactions",
    why_features: [
      { t: "Lightning-fast delivery", d: "We commit to clear deadlines and finish your transactions as fast as possible — that is what our name means." },
      { t: "Deep platform expertise", d: "A team that knows every government platform's rules and keeps its knowledge constantly updated." },
      { t: "Total security & privacy", d: "Your business data stays fully confidential, with documented and legal authorizations only." },
    ],
    ch_testimonials: "Testimonials",
    testimonials_title: "What our clients say",
    testimonials: [
      { q: "What impressed me about Barq Safe is the total confidentiality with our healthcare facilities' data and the precision of every authorization. A partner truly worthy of trust.", n: "Dr. Ibrahim Al-Tamimi", r: "Healthcare sector investor" },
      { q: "Unexpectedly fast execution — they completed our startup formation and commercial registration within days, and their handling of government platforms is professional from the very first message.", n: "Ms. Sara Al-Otaibi", r: "CEO of a tech startup" },
      { q: "They fully manage our Qiwa and Muqeem accounts; work permits and residencies are completed before expiry with early alerts. They saved us an entire government-affairs hire.", n: "Eng. Khaled Al-Shammari", r: "General Manager of a contracting group" },
      { q: "As a retail entrepreneur, what I loved most is the easy communication and clear steps — my Balady licenses and commercial registration arrived without visiting a single entity.", n: "Ms. Munira Al-Dossari", r: "Retail sector entrepreneur" },
      { q: "From the investment license to the bank account and visas, they walked with us step by step until we launched our logistics platform. A smooth, professional formation experience.", n: "Eng. Faisal bin Jassim", r: "Co-founder of a logistics platform" },
      { q: "I work with them on my clients' foreign company formation files; their legal compliance and notarization professionalism made them my first choice for every formation.", n: "Dr. Reem Al-Fayez", r: "Legal consultant for foreign companies" },
    ],
    ch_faq: "FAQ",
    faq_title: "Questions? We have answers",
    faq: [
      { q: "Which government platforms do your services cover?", a: "We cover all Saudi government platforms: Qiwa, Muqeem, Absher Business, Ministry of Commerce, Saudi Business Center, Ministry of Investment, GOSI, Balady, ZATCA, Mudad and more." },
      { q: "Can you form a company for a foreign investor fully remotely?", a: "Yes, most steps are done electronically: MISA license, articles of association, commercial registration and national address — and we guide you through any required in-person steps such as bank account opening." },
      { q: "How do the annual packages work?", a: "With one annual subscription we become your government-affairs department: managing your platform accounts, executing transactions, and reminding you of renewals before they expire." },
      { q: "Is my business data safe with you?", a: "Absolutely. We work with officially documented authorizations, keep all your documents strictly confidential, and never request permissions beyond the service scope." },
      { q: "How do I get started?", a: "Simply fill the free consultation form or message us on WhatsApp at +966 57 946 2600 and a specialist will reach out during business hours." },
    ],
    ch_contact: "Contact Us",
    contact_title: "Get your free consultation",
    contact_sub: "Tell us what you need and a Barq Safe specialist will reach out as soon as possible.",
    form_name: "Full name",
    form_phone: "Mobile number",
    form_email: "Email (optional)",
    form_service: "Required service",
    form_message: "Your request details",
    form_submit: "Send Request",
    form_sending: "Sending...",
    form_success: "Your request has been received! We will contact you soon.",
    form_error: "Could not send the request. Try again or reach us on WhatsApp.",
    sp_back: "Back to Home",
    sp_included: "What's included?",
    sp_steps: "How we deliver it",
    sp_cta_btn: "Request This Service",
    sp_all_services: "Other services",
    contact_call: "Call us",
    contact_whatsapp: "WhatsApp",
    contact_email: "Email",
    contact_location: "Location",
    contact_location_value: "Riyadh, As Suwaidi Dist., As Suwaidi Public St., Inside Al Qasr Mall, P.O. Box: 11564",
    map_title: "Find us on the map",
    map_directions: "Get Directions",
    stories_link: "Read our clients' success stories",
    stories_title: "Real success stories from our clients",
    stories_sub: "Concrete numbers and results achieved by Barq Safe clients — from foreign company formation to full government platform management.",
    story_challenge: "The Challenge",
    story_solution: "The Solution",
    story_results: "Results in Numbers",
    story_quote_label: "In their words",
    service_investor: "Company formation for a foreign investor",
    service_other: "Other service",
    footer_about: "Barq Safe Business Solutions — your trusted partner for electronic government transactions and company formation for foreign investors in Saudi Arabia.",
    footer_links: "Quick Links",
    footer_platforms: "Platforms",
    footer_contact: "Contact",
    footer_rights: "Barq Safe Business Solutions — All rights reserved",
    whatsapp_aria: "Chat on WhatsApp",
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => (localStorage.getItem("bs_lang") === "en" ? "en" : "ar"));
  useEffect(() => {
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [lang]);
  const setLang = (l) => {
    localStorage.setItem("bs_lang", l);
    setLangState(l);
  };
  const t = (key) => translations[lang][key] ?? translations.ar[key] ?? key;
  return (
    <LangContext.Provider value={{ lang, setLang, t, dir: lang === "ar" ? "rtl" : "ltr" }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
